import { IS_MOBILE } from '@/app.config';

const OpenLinkMixin = {
  methods: {
    // Abre un link en el navegador fuera de la aplicación
    openLinkMixin(link, cbClosed) {
      if (IS_MOBILE) {
        // eslint-disable-next-line no-undef
        if (SafariViewController !== undefined) {
          // eslint-disable-next-line no-undef
          SafariViewController.isAvailable(available => {
            if (available) {
              // eslint-disable-next-line
                SafariViewController.show(
                {
                  url: link,
                  hidden: false,
                  animated: true,
                  transition: 'curl',
                },
                result => {
                  if (result.event === 'closed') {
                    console.log('closed');
                    if (cbClosed !== undefined) {
                      cbClosed();
                    }
                  }
                },
                error => {
                  console.error(error);
                }
              );
            } else {
              // eslint-disable-next-line no-undef
              cordova.InAppBrowser.open(link, '_system', 'location=no');
            }
          });
        } else {
          // eslint-disable-next-line no-undef
          cordova.InAppBrowser.open(link, '_system', 'location=no');
        }
      } else {
        window.open(link);
      }

      return false;
    },
  },
};

export default OpenLinkMixin;
